import { generateClassName } from '@klv/shared/utils/functions';

import * as s from './styles/jump-anchor.module.scss';

import type { IJumpAnchor } from './types';

const JumpAnchor = ({ className, id }: IJumpAnchor) => (
  <div className={generateClassName([s.jumpAnchor, className])} id={id} />
);

export default JumpAnchor;
